const SvgOperatingSystems2 = (props) => (
  <>
    <path fill="none" stroke={props.p30} strokeMiterlimit={10} d="M15.99.09H0v15.63" />
    <path fill={props.p30} d="M192 95.91v96H96v-96z" />
    <path fill={props.p20} d="M160 63.91v96H64v-96z" />
    <path fill={props.p10} d="M128 31.91v96H32v-96z" />
    <path fill={props.p20} stroke={props.p30} strokeMiterlimit={10} d="m.4.11 79.63 79.78" />
    <circle cx={79.48} cy={80.07} r={4} fill={props.p30} />
  </>
);

export default SvgOperatingSystems2;
